import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-floating-menu-button',
  templateUrl: './floating-menu-button.component.html',
  styleUrls: ['./floating-menu-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FloatingMenuButtonComponent implements OnInit {
  public clicked = false;

  @Input() unclickedClass;
  @Input() clickedClass;
  @Input() visible;
  @Input() clickeable;

  @Output() public onClick: EventEmitter<any>;

  constructor() {
    this.onClick = new EventEmitter();
  }

  ngOnInit(): void {
  }

  buttonClicked() {
    if (this.clickeable) {
      this.clicked = !this.clicked;
    }
    this.onClick.emit();
  }

}
